import { useQueryClient } from 'react-query';
import { QueryKeys } from '../../../../core/queries/query-keys.constants';
import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';
import {
  useMutationDeleteRegistrationPage,
  useQueryGetRegistrationPageOptional
} from '../../../registration-pages/queries';

export interface DeleteRegistrationPageModalProps {
  projectId: string;
  registrationPageId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export function DeleteRegistrationPageModal(props: DeleteRegistrationPageModalProps) {
  const queryClient = useQueryClient();
  const page = useQueryGetRegistrationPageOptional(props.projectId, props.registrationPageId);

  const mutation = useMutationDeleteRegistrationPage();

  const onConfirm = async () => {
    await mutation.mutateAsync({ projectID: props.projectId, registrationPageID: props.registrationPageId });
    queryClient.invalidateQueries(QueryKeys.SETTINGS);
    props.onSuccess();
  };

  const errorMessage = !page.data
    ? 'Sorry, there was an error loading the Registration Page. Please close the modal and try again'
    : undefined;

  return (
    <ConfirmationModal
      title="Delete Registration Page?"
      onCancel={props.onCancel}
      onConfirm={onConfirm}
      warning={`Are you sure?`}
      isLoading={page.isLoading || mutation.isLoading}
      content={[]}
      errorMessage={errorMessage}
      noteRequired={false}
      actionButton={{
        label: 'Delete',
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel',
        color: 'secondary'
      }}
    />
  );
}
